import { IUpdateAvaliacaoOrdemCompraUseCase } from "../../../presentation/useCases/update/update_avaliacao_ordem_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateAvaliacaoOrdemCompraUseCase
 */

export class UpdateAvaliacaoOrdemCompraUseCase implements IUpdateAvaliacaoOrdemCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateAvaliacaoOrdemCompra(
    idOrdemCompra: number,
    statusEntrega: number,
    statusNfEntrega: number | null,
    data: Date | null,
    avaliadoPor: number | null | undefined,
    nroNotaFiscal: string | null | undefined,
    observacao: string | null | undefined,
    arquivo: File | null,
    limparArquivo: boolean,
    arquivoBoleto: File | null,
    limparArquivoBoleto: boolean,
    criterioItems: {
      idCriterioAvaliacaoFornecedor: number;
      idItemAvaliacaoFornecedor: number | null;
      nota: number | null;
    }[],
  ): Promise<void> {
    await this.repository.updateAvaliacaoOrdemCompra(
      idOrdemCompra,
      statusEntrega,
      statusNfEntrega,
      data,
      avaliadoPor ?? null,
      nroNotaFiscal ?? null,
      observacao ?? null,
      arquivo,
      limparArquivo,
      arquivoBoleto,
      limparArquivoBoleto,
      [...criterioItems.map(item => ({
        idCriterioAvaliacaoFornecedor: item.idCriterioAvaliacaoFornecedor,
        idItemAvaliacaoFornecedor: item.idItemAvaliacaoFornecedor,
        nota: item.nota,
      }))],
    );
  }
}
